module.exports = __webpack_public_path__ + "img/poster.1f4fd257.png";